import {
  ECampaignAgentAccessScope,
  ECampaignKeys,
  TCampaignAgentJunction,
} from '~/features/campaigns/models'

type TCampaignLike = Record<string, unknown> | null | undefined

export const isSharedCampaign = (campaign: TCampaignLike): boolean =>
  campaign?.[ECampaignKeys.agentAccessScope] ===
  ECampaignAgentAccessScope.shared

export const getCampaignJunctions = (
  campaign: TCampaignLike,
): TCampaignAgentJunction[] => {
  if (!campaign) {
    return []
  }

  return (
    (campaign[ECampaignKeys.campaignAgentJunctions] as
      | TCampaignAgentJunction[]
      | undefined) ||
    (campaign.CampaignAgentJunction as TCampaignAgentJunction[] | undefined) ||
    []
  )
}

/** For non-shared campaigns: the single junction assistant, else `agentId`. */
export const getNonSharedCloneOriginalAssistantId = (
  campaign: TCampaignLike,
): string => {
  if (!campaign) {
    return ''
  }

  const junctions = getCampaignJunctions(campaign)
  if (junctions.length === 1) {
    const id = String(
      junctions[0].agentId || junctions[0].Agent?.id || '',
    ).trim()
    if (id) {
      return id
    }
  }

  const agentId = campaign[ECampaignKeys.agentId] ?? campaign.agentId
  return String(agentId ?? '').trim()
}

/** Shared campaigns with multiple assistants need explicit CSV/email routing; otherwise the backend assigns automatically. */
export const campaignRequiresManualAssistantRouting = (
  campaign: TCampaignLike,
): boolean => {
  if (!campaign) {
    return false
  }

  if (!isSharedCampaign(campaign)) {
    return false
  }

  return getCampaignJunctions(campaign).length > 1
}

export default getCampaignJunctions
